<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><a id="page_vii"></a>Contents</p>
<p class="imagec"><img alt="" height="4" src="images/line.jpg" width="630"/></p>
<p class="tocf0"><span class="hide">        </span><a href="#/xhtml/Preface">Preface</a></p>
<p class="tocf"><span class="hide">        </span><a href="#/xhtml/Foreword">Foreword to the Hebrew Edition</a></p>
<p class="tocf"><span class="hide">        </span><a href="#/xhtml/Foreword01">Foreword to the English Edition</a></p>
<p class="tocf"><span class="hide">        </span><a href="#/xhtml/Acknowledgments">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/Introduction">Introduction</a></p>
<p class="toc"><a href="#/xhtml/Chapter01">1.<span class="spacec"><span class="hide">    </span>Nurit: Surviving Social Marginality</span></a></p>
<p class="toc"><span href="#/xhtml/Chapter02" title="Link target outside of Sample">2.<span class="spacec"><span class="hide">    </span>Efrat and Her Daughters: The Road to Religious Observance</span></span></p>
<p class="toc"><span href="#/xhtml/Chapter03" title="Link target outside of Sample">3.<span class="spacec"><span class="hide">    </span>Rachel: Yerucham’s “Ideal Resident”</span></span></p>
<p class="toc"><span href="#/xhtml/Chapter04" title="Link target outside of Sample">4.<span class="spacec"><span class="hide">    </span>Rachel’s Juggling Act and Its Limits</span></span></p>
<p class="toc"><span href="#/xhtml/Chapter05" title="Link target outside of Sample">5.<span class="spacec"><span class="hide">    </span>Esti: Subversive Interpretation of a Constrained Reality</span></span></p>
<p class="toc"><span href="#/xhtml/Chapter06" title="Link target outside of Sample">6.<span class="spacec"><span class="hide">    </span>Esti the Rebel: No One Will Speak for Her</span></span></p>
<p class="toc"><span href="#/xhtml/Chapter07" title="Link target outside of Sample">7.<span class="spacec"><span class="hide">    </span>Gila: A Story of Success</span></span></p>
<p class="toc"><span href="#/xhtml/Conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="tocf"><span class="hide">        </span><span href="#/xhtml/Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="tocf"><span class="hide">        </span><span href="#/xhtml/References" title="Link target outside of Sample"><i>References</i></span></p>
<p class="tocf"><span class="hide">        </span><span href="#/xhtml/Index" title="Link target outside of Sample"><i>Index</i></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3944d184